import type { ReactNode } from 'react';
import { Divider } from 'antd';

export function PageFooter({ children }: { children: ReactNode }) {
    return (
        <div className='sticky bottom-0 z-10 mt-auto bg-white'>
            <Divider className='m-0' />
            <div className='flex flex-wrap justify-center gap-2 border-t-4 border-t-gray-500 p-2'>
                {children}
            </div>
        </div>
    );
}
